import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Level } from 'components/Modals/Modal/type';
import { ITestExtraPriceQuestion } from 'types/Configuration.types';
import {
  TriggerLabel,
  TriggerWrapper,
} from 'pages/DealerPanel/DealerPanelModelsPage/DealerPanelCategory/ModelConfiguration/QuestionsManager/QuestionsManagerButton/QuestionsManagerButton.styled';
import { LocalExtraPriceManagerModal } from './LocalExtraPriceManagerModal';

interface ILocalExtraPriceManagerButtonProps {
  questions: ITestExtraPriceQuestion[];
  setQuestions: (questions: ITestExtraPriceQuestion[]) => void;
  modelName: string;
  currency: string;
  level?: Level;
}

// "Extra price" entry point inside the test configuration modal. Unlike the
// dealer-panel button, this edits a local copy (no server CRUD) so the supplier
// can test the model with these values without persisting them.
export const LocalExtraPriceManagerButton = ({
  questions,
  setQuestions,
  modelName,
  currency,
  level = 'SECOND',
}: ILocalExtraPriceManagerButtonProps) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const hasActiveQuestions = questions.some((question) => question.is_active);

  return (
    <TriggerWrapper>
      <TriggerLabel
        isActive={hasActiveQuestions}
        isDisabled={false}
        onClick={() => setIsOpen(true)}
      >
        {t('Extra questions')}
      </TriggerLabel>
      <LocalExtraPriceManagerModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        questions={questions}
        setQuestions={setQuestions}
        modelName={modelName}
        currency={currency}
        level={level}
      />
    </TriggerWrapper>
  );
};
